export default "__VITE_ASSET__7d7317b5__"